import app from "js/legacy-app";

app.filter("selectColorClass", [function () {
    return function (colors, count) {
        return 'show-chosen-color ' + (colors.length == count ? 'active' : '');
    };
}]);